import {
  Stack,
  type StackProps,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { ReactNode } from "react";

interface LabelTextProps extends Omit<StackProps, "children"> {
  label: string;
  labelVariant?: TypographyProps["variant"];
  bodyVariant?: TypographyProps["variant"];
  children: ReactNode;
  vertical?: boolean;
}

const LabelText = ({
  label,
  labelVariant = "body2",
  bodyVariant = "body2",
  children,
  vertical = false,
}: LabelTextProps) => {
  const muiDirection = vertical ? "column" : "row";

  return (
    <Stack direction={muiDirection} spacing={1} alignItems="baseline">
      <Typography
        variant={labelVariant}
        fontWeight="bold"
        sx={{ flexShrink: 0 }}
      >
        {label}:
      </Typography>
      <Typography
        variant={bodyVariant}
        sx={{ overflowWrap: "break-word", minWidth: 0 }}
      >
        {children}
      </Typography>
    </Stack>
  );
};

export default LabelText;
